var synerionData;
;(function ($) {

  var WP = synerionData,
    searchToggleButton = $('#z_search_toggle'),
    searchformHeader = $('#z_searchform_header'),
    searchField = $('#z_searchform_header_field'),
    slickSlider = $('#masthead_slider');

  document.addEventListener('scroll', initScriptsOnEvent);
  document.addEventListener('mousemove', initScriptsOnEvent);
  document.addEventListener('touchstart', initScriptsOnEvent);
  document.addEventListener('keydown', initScriptsOnEvent);

  $(document).ready(function () {

    initAnimatedNumbers();

    $('body').on('click', '#z_search_toggle', searchToggle);
    $('body').on('click', '.show-hide-button', showHideToggle);

    $('.team-member-portrait').on({
      mouseover: function () {
        console.log('hovering');
        var $this = $(this),
          hoverImage = $this.find('.portrait-hover');

        hoverImage.fadeIn();
        //stuff to do on mouse enter
      },
      mouseleave: function () {
        console.log('not hovering');
        //stuff to do on mouse leave
        var $this = $(this),
          hoverImage = $this.find('.portrait-hover');

        hoverImage.fadeOut();
      }
    });
    initShowHideToggle();

    if ($('body').hasClass('page-template-template-masthead-cta-crossfade')) {
      initSlickSlider()
    }
    if ($('body').hasClass('page-template-template-masthead-slider-cta-crossfade')) {
      initSlickSliderDots()
    }

  });

  /**
   * Loads scripts after website interaction.  This is to improve performance.
   * - Google Tag Manager Script
   * - Homepage video script
   *
   * @returns {boolean}
   */
  function initScriptsOnEvent() {
    if (window.gtmDidInit) {
      return false;
    }

    if ($('body').hasClass('home') && (!window.videoLoaded)) {
      // console.log('initGTMOnEvent() is homepage', WP.video_url);
      var videocontainer = '#video_shell', // set the ID of the container that you want to insert the video in
        video = WP.video_tag; // setup the video element
      $(videocontainer).append(video); // insert the video element into its container
      videl = $(document).find('#intro-video')[0]; // find the newly inserted video
      window.videoLoaded = true;
    }

    window.gtmDidInit = true; // flag to ensure script does not get added to DOM more than once.
    const gtmScript = document.createElement('script');
    gtmScript.type = 'text/javascript';
    gtmScript.async = true;
    gtmScript.onload = () => {
      dataLayer.push({event: 'gtm.js', 'gtm.start': (new Date()).getTime(), 'gtm.uniqueEventId': 0});
    } // this part ensures PageViews is always tracked
    gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KBS8LC';

    document.head.appendChild(gtmScript);
  }

  function initAnimatedNumbers() {

    var waypoints = $('.feature-buckets.animated').waypoint({
      handler: function () {
        animateNumbers();
      },
      offset: '75%'
    })

  }

  function animateNumbers() {
    // https://www.jqueryscript.net/animation/Simple-jQuery-Plugin-To-Animate-Numeric-Text-Animate-Numbers.html
    $('.counter').each(function (index, item) {
      let $this = $(item),
        countTo = $this.attr('data-count');
      $this.animateNumbers(countTo, true, 4000);
    });
  }


  /**
   * Toggles the search bar in the header and then focuses in the search bar once it appears.
   *
   * @param {object} e
   * @returns {void}
   */
  function searchToggle() {
    //console.log( 'searchToggle' );

    if (searchformHeader.hasClass('open')) {
      searchToggleButton.removeClass('open');
      searchformHeader.removeClass('open');
      searchformHeader.attr('aria-hidden', true);
    } else {
      searchformHeader.addClass('open');
      searchToggleButton.addClass('open');
      searchformHeader.attr('aria-hidden', false);
      searchField.focus();
    }

  }


  /**
   * Show/Hide Accordion Toggle.
   */
  function showHideToggle() {
    // console.log('showHideToggle');
    var $this = $(this),
      content = $this.siblings('.show-hide-content');

    if (content.hasClass('show')) {
      console.log('close toggle');
      content.removeClass('show');
      $this.removeClass('up-arrow');
      content.attr('aria-hidden', true);
    } else {
      console.log('open toggle');
      content.addClass('show');
      $this.addClass('up-arrow');
      content.attr('aria-hidden', false);
    }
  }

  /**
   * Init the Show/Hide Accordions, Covers NO-JS
   */
  function initShowHideToggle() {
    var showHideContent = $('.show-hide-content'),
      showHideButton = $('.show-hide-button');
    if (showHideContent) {
      showHideContent.removeClass('show');
      showHideContent.attr('aria-hidden', true);
    }
    if (showHideButton) {
      showHideButton.removeClass('minus');
    }
  }

  /**
   * Init the Slider(s) if any are on page.
   */
  function initSlickSlider() {

    if (slickSlider) {

      $('#masthead_slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        speed: 1200,
        fade: true,
        cssEase: 'linear'
      });
    }

  }

  /**
   * Init the Slider(s) if any are on page.
   */
  function initSlickSliderDots() {

    if (slickSlider) {

      $('#masthead_slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        speed: 1200,
        fade: true,
        cssEase: 'linear',
        dots: true
      });
    }

  }

  // $(window).load(function () {
  //   if (Foundation.MediaQuery.atLeast('medium')) {
  //     initFullResImages();
  //   }
  // });
  //
  // /**
  //  * Looks for any image with data attribute: data-full-res and swaps out the low res version with full res.
  //  */
  // function initFullResImages() {
  //   // console.log('initFullResImages');
  //   $('[data-full-res]').each(function (index, item) {
  //     var $this = $(item),
  //       fullResURL = $this.attr('data-full-res');
  //
  //
  //     var image = document.images[index];
  //     var downloadingImage = new Image();
  //     downloadingImage.onload = function () {
  //       $this.css('background-image', 'url(' + fullResURL + ')');
  //     };
  //     downloadingImage.src = fullResURL;
  //
  //   });
  // }

  $(window).on('changed.zf.mediaquery', function (event, name) {
    console.log('Breakpoint Watch: ', name);
  });

})(jQuery);
